export const CACHE_CONTROL_30_SEC_CDN_CACHE =
  'public, max-age=0, s-maxage=30, stale-if-error=0, must-revalidate'

export const CACHE_CONTROL_10_MIN_CDN_CACHE =
  'public, max-age=0, s-maxage=600, stale-if-error=0, must-revalidate'

export const CACHE_CONTROL_NO_CACHE =
  'private, no-cache, no-store, stale-if-error=0, must-revalidate, max-age=0'
